import numeral from 'numeral'

export default function longNumberToShort(number, format = '0.00a') {
  if (format === '0.0a' && number < 10000 && number > -10000) {
    return number
  }

  return numeral(number).format(format)
}
